export default __webpack_public_path__ + "static/media/QA.b569c009.svg";